import { usePurchaseContractDetailDispatch } from './purchase-contract-detail-context';
import PortalAppService from '../../../application/platform/portal-app-service';

export function usePurchaseContractDetailController() {
  const dispatch = usePurchaseContractDetailDispatch();

  const loadDetail = async (id: number) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.requestPurchaseContractDetail(id);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar detalhes do contrato';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  return {
    loadDetail,
  };
}
